// extracted by mini-css-extract-plugin
export default {"input-touched":"style_input-touched__noaJk"};